import { mainGroups } from "@/core/MainGroups";
import { seatsGroups } from "@/core/SeatsGroup";

const syncSeatBindFromNode = (seatBind, seatNode) => {
  if (seatNode.tempInvalid !== undefined) {
    seatBind.invalid = seatNode.tempInvalid;
  } else if (seatNode.invalid !== undefined) {
    seatBind.invalid = seatNode.invalid;
  }

  if (
    seatNode.tempNumber !== undefined &&
    seatNode.tempNumber !== null &&
    seatNode.tempNumber !== ""
  ) {
    seatBind.number = seatNode.tempNumber;
    seatBind.editedNumber = seatNode.tempNumber;
  } else if (
    seatNode.editedNumber !== undefined &&
    seatNode.editedNumber !== null &&
    seatNode.editedNumber !== ""
  ) {
    seatBind.number = seatNode.editedNumber;
    seatBind.editedNumber = seatNode.editedNumber;
  } else if (seatNode.number !== undefined && seatNode.number !== null) {
    seatBind.number = seatNode.number;
  }
};

// Persist unsaved Konva edits into seatsBind before section/table rebuild.
export const syncPendingSeatEditsToSeatsBind = (layerId) => {
  const currentGroup = mainGroups.get(layerId);
  const currentSeats = seatsGroups.get(layerId);
  if (!currentGroup || !currentSeats) return;

  const isSection = currentGroup.attrs.type === "section";
  const seatsBind = currentGroup.seatsBind;
  if (!seatsBind) return;

  const seats = currentSeats.children;

  seats.forEach((seatNode) => {
    if (!isSection) {
      const seatBind = seatsBind.find((s) => s.id === seatNode.getId());
      if (seatBind) syncSeatBindFromNode(seatBind, seatNode);
      return;
    }

    const rowIndex = seatNode.attrs?.pos?.[0];
    const seatIndex = seatNode.attrs?.pos?.[1];
    if (rowIndex === undefined || seatIndex === undefined) return;

    const rowBind = seatsBind[rowIndex];
    const seatBind = rowBind?.seats?.[seatIndex];
    if (!seatBind) return;

    syncSeatBindFromNode(seatBind, seatNode);

    if (seatNode.tempRow !== undefined) {
      rowBind.editedKey = seatNode.tempRow;
      rowBind.key = seatNode.tempRow;
    }
  });

  if (isSection) {
    seatsBind.forEach((row) => {
      if (row.tempRowSeatStartsWith !== undefined) {
        row.rowSeatStartsWith = row.tempRowSeatStartsWith;
        return;
      }

      const rowSeatNode = seats.find(
        (s) =>
          s.rowId === row.id &&
          (s.attrs?.rowSeatStartsWith !== undefined || s.rowSeatStartsWith !== undefined)
      );
      const fromNode =
        rowSeatNode?.attrs?.rowSeatStartsWith ?? rowSeatNode?.rowSeatStartsWith;
      if (fromNode !== undefined && fromNode !== null && fromNode !== "") {
        row.rowSeatStartsWith = fromNode;
      }
    });
  }

  currentGroup.seatsBind = seatsBind;
  currentGroup.setAttrs({ seatsBind });
};
